<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label>Master Account</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="watchlistFilter"
            :options="watchlistOptions"
            label="label"
            class="w-100"
            multiple
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:watchlistFilter', val)"
            append-to-body
            :calculate-position="withPopper"
          />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    watchlistOptions: {
      type: Array,
      default: null,
    },
    masterAccountOptions: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
